import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import {Button} from '../../../atoms/Buttons/Button';
import {ButtonProps} from '../../../atoms/Buttons/types';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 */
export const BasketLoginButton: FC<{
  onClick?: ButtonProps['onClick'];
  dataTestId: string;
}> = ({onClick, dataTestId}) => {
  const {t} = useTranslation();

  return (
    <Button variant="secondary" onClick={onClick} data-testid={dataTestId}>
      {t('Log in')}
    </Button>
  );
};
